import { strCode } from "../../localizations/strCode";

const fwuCampaignsErrors = {
  UPDATE_PACKAGE_NOT_FOUND: strCode.UPDATE_PACKAGE_NOT_FOUND,
  SIGNATURE_FILE_IS_INVALID_BASE64_CONTENT: strCode.SIGNATURE_FILE_IS_INVALID_BASE64_CONTENT,
  OTA_UPDATE_ALREADY_EXISTS: strCode.OTA_UPDATE_ALREADY_EXISTS,
  CORRECT_DUSNS_NOT_FOUND: strCode.CORRECT_DUSNS_NOT_FOUND,
  CAMPAIGN_NAME_ALREADY_EXISTS: strCode.CAMPAIGN_NAME_ALREADY_EXISTS,
  HTTP_METHOD_IS_NOT_SUPPORTED: strCode.HTTP_METHOD_IS_NOT_SUPPORTED,
  INVALID_ADMIN_GROUP: strCode.INVALID_ADMIN_GROUP,
  REQUEST_QUERY_IS_NOT_PROVIDED: strCode.REQUEST_QUERY_IS_NOT_PROVIDED,
  NOTIFICATION_CAMPAIGN_NOT_FOUND: strCode.NOTIFICATION_CAMPAIGN_NOT_FOUND,
  NOTIFICATION_CAMPAIGN_ALREADY_DEACTIVATED: strCode.NOTIFICATION_CAMPAIGN_ALREADY_DEACTIVATED,
  NOTIFICATION_CAMPAIGN_ALREADY_STARTED: strCode.NOTIFICATION_CAMPAIGN_ALREADY_STARTED,
  NOTIFICATION_MESSAGE_NOT_FOUND: strCode.NOTIFICATION_MESSAGE_NOT_FOUND,
};

export default fwuCampaignsErrors;
